import React, {Component} from 'react';
import { Link } from 'react-router-dom';

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
//import pic1 from "../../images/about/pic-1.jpg";
import icon1 from "../../images/icon/icon1.png";
import icon2 from "../../images/icon/icon2.png";
import icon3 from "../../images/icon/icon3.png";
import facebook from '../../images/social/facebook.png';
import instagram from '../../images/social/instagram.png';
import twitter from '../../images/social/twitter.png';

// import animateWave from "../../images/shap/wave-blue.png";
// import animate2 from "../../images/shap/circle-dots.png";
// import animateRotate from "../../images/shap/plus-blue.png";
import AppointmentForm from '../elements/appointment-form';


class ContactUs extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner banner-lg contact-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Contact Us</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Contact Us</li>
										</ul>
									</nav>
								</div>
							</div>
							{/* <img className="pt-img1 animate-wave" src={animateWave} alt=""/>
							<img className="pt-img2 animate2" src={animate2} alt=""/>
							<img className="pt-img3 animate-rotate" src={animateRotate} alt=""/> */}
						</div>
					</div>
					
					<section className="">
						<div className="container">
							<div className="contact-wraper">
								<div className="row">
									 <div className="col-lg-6 mb-30">
										{/*<form className="form-wraper contact-form ajax-form">
											<div className="ajax-message"></div>
											<div className="row">
												<div className="form-group col-md-12">
													<input name="name" type="text" required className="form-control" placeholder="Your Name"/>
												</div>
												<div className="form-group col-md-12">
													<input name="email" type="email" required className="form-control" placeholder="Email"/>
												</div>
												<div className="form-group col-md-12">
													<input name="phone" type="text" required className="form-control" placeholder="Phone Numbers"/>
												</div>
												<div className="form-group col-md-12">
													<select className="form-select form-control">
														<option defaultValue="Selecty Department">Selecty Department</option>
														<option defaultValue="1">One</option>
														<option defaultValue="2">Two</option>
														<option defaultValue="3">Three</option>
													</select>
												</div>
												<div className="form-group col-md-12">
													<textarea name="message" required className="form-control" placeholder="Type Message"></textarea>
												</div>
												<div className="col-lg-12">
													<button name="submit" type="submit" defaultValue="Submit" className="btn w-100 btn-secondary btn-lg">Submit</button>
												</div>
											</div>
										</form>*/}
										<div>
											<AppointmentForm />
										</div>
									</div> 
									{/* style={{backgroundImage: "url("+pic1+")"}} */}
									<div className="col-lg-6 mb-30">
										<div className="contact-info ovpr-dark" >
											<div className="info-inner">
												<h4 className="title mb-30">Any Questions? Contact Us!</h4>
												<div className="icon-box">
													<h6 className="title"><i className="ti-map-alt"></i>Location</h6>		
													<p>407 39th Street, Suite 401, Union City, NJ, 07087, USA</p>
												</div>
												<div className="icon-box">
													<h6 className="title"><i className="ti-id-badge"></i>Email &amp; Phone</h6>		
													<Link to="#" className="text-white">team@familyecodental.com</Link>
													<p>201-330-2837</p>
												</div>
												<div className="icon-box">
													<h6 className="title"><i className="ti-world"></i>Follow Us</h6>
													<ul className="social-media">
														<li><a rel="noreferrer" target="_blank" href="https://www.facebook.com/FamilyEcodental"><img src={facebook} alt=""/></a></li>
														<li><a rel="noreferrer" target="_blank" href="https://www.tiktok.com/@familyecodental?lang=en&is_from_webapp=1&sender_device=mobile&sender_web_id=7259612774368462382"><img src={twitter} alt=""/></a></li>
														<li><a rel="noreferrer" target="_blank" href="https://www.instagram.com/family_eco_dental/?next=%2F"><img src={instagram} alt=""/></a></li>
													</ul>
												</div>
												<div className="icon-box">
													<div className="widget">										
														<h5 className="title">Fill Out Our Forms Here!</h5>
																						<ul className="service-menu">
																							<li><Link to="https://forms.wv3.io/form?formId=06e94363-66d2-4e2c-bfb7-d23726889a5b&companyId=1e664556-4582-4516-8686-98fa232fe853"><span>Health History Form English</span><i className="fa fa-angle-right"></i></Link></li>
																							<li><Link to="https://forms.wv3.io/form?formId=a08ebbd6-8b00-44f7-b7c1-5e74dd180fd1&companyId=1e664556-4582-4516-8686-98fa232fe853"><span>Health History Form Spanish</span><i className="fa fa-angle-right"></i></Link></li>										
																						</ul>											
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					
					<section className="section-area section-sp1">
						<div className="container">
							<div className="row">
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature4">
										<div className="icon-md feature-icon">
											<img src={icon1} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Contact Number</h5>
											<p>201-330-2837</p>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature3">
										<div className="icon-md feature-icon">
											<img src={icon3} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Email Address</h5>
											<p>team@familyecodental.com</p>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 mb-30">
									<div className="feature-container feature-bx4 feature2">
										<div className="icon-md feature-icon">
											<img src={icon2} alt=""/>
										</div>
										<div className="icon-content">
											<h5 className="ttr-title">Address</h5>
											<p>407 39th Street, Suite 401, Union City, NJ, 07087, USA</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				
				</div>
				
			</>
		);
	}
}

export default ContactUs;